import { useNavigate } from 'react-router-dom';

import { useCallback } from 'react';

import { useRouteChange } from '@/hooks/useRouteChangeHandler';

export function useRouter() {
  const navigate = useNavigate();
  const { startRouteChange } = useRouteChange();

  const push = useCallback(
    (href: string) => {
      // Don't trigger loading for same-page anchors
      if (!href.startsWith('#') && href !== window.location.pathname) {
        startRouteChange();
      }
      navigate(href);
    },
    [navigate, startRouteChange]
  );

  const replace = useCallback(
    (href: string) => {
      // Don't trigger loading for same-page anchors
      if (!href.startsWith('#') && href !== window.location.pathname) {
        startRouteChange();
      }
      navigate(href, { replace: true });
    },
    [navigate, startRouteChange]
  );

  const back = useCallback(() => {
    startRouteChange();
    navigate(-1);
  }, [navigate, startRouteChange]);

  const forward = useCallback(() => {
    startRouteChange();
    navigate(1);
  }, [navigate, startRouteChange]);

  const refresh = useCallback(() => {
    window.location.reload();
  }, []);

  return {
    push,
    replace,
    back,
    forward,
    refresh,
  };
}
